
import {
    defineComponent, PropType, computed, toRefs, unref, SetupContext,
} from '@vue/composition-api';
import CheckBoxInputListWithOneSelect from '@ve/components/inputs/CheckBoxInputListWithOneSelect.vue';
import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
import RadioInput from '@ve/components/inputs/RadioInput.vue';
import FilterListItem from '@ve/components/searchFilters/filterList/desktop/FilterListItem.vue';
import TextCommon from '@ve/components/inputs/TextCommon.vue';
import FilterItemPosition from '@ve/components/filters/common/components/filterItemPosition/FilterItemPosition.vue';
import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
import FilterAttributeMethods from '@ve/components/filters/common/filterMethods/filterAttributeMethods/FilterAttributeMethods';
import { IFilterAttribute } from '@ve/components/filters/common/types';
import { SerpHotelAdapted } from '@fr/vue/components/searchFilters/store/types';

export default defineComponent({
    name: 'FilterListRender',
    model: {
        prop: 'selected',
        event: 'change',
    },
    components: {
        FilterListItem,
        FilterItemPosition,
        TextCommon,
        HintTooltip,
        RadioInput,
        CheckBoxInput,
    },
    props: {
        filterAttributeMethods: {
            type: Object as PropType<FilterAttributeMethods<IFilterAttribute, number | number[] | boolean>>,
            required: true,
        },
        firstCheckboxName: {
            type: String,
            default: '',
        },
        enableOnlyCheckBox: {
            type: Boolean,
            default: true,
        },
        selected: {
            type: [Array, Number] as PropType<number[] | number>,
            default: () => [],
            required: true,
        },
        filteredHotels: {
            type: Array as PropType<SerpHotelAdapted[]>,
            default: () => [],
            required: true,
        },
        allHotels: {
            type: Array as PropType<SerpHotelAdapted[]>,
            default: () => [],
            required: true,
        },
        visibleCounter: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, { emit }: SetupContext) {
        const { selected, filteredHotels, allHotels } = toRefs(props);
        const { filterAttributeMethods } = props;
        const isModelValuesArray = computed(() => Array.isArray(unref(selected)));

        const anySelectedModelArray = computed({
            get: () => {
                const selectedIds = unref(selected) as number[];
                return !selectedIds.length;
            },
            set: () => {
                emit('change', []);
                emit('selectedAny');
            },
        });
        const anySelectedModelNumber = computed({
            get: () => {
                const selectedId: number = unref(selected) as number;
                return selectedId;
            },
            set: () => {
                emit('change', 0);
                emit('selectedAny');
            },
        });

        const selectedValues = computed({
            get: () => unref(selected),
            set: (value: number[] | number) => {
                emit('change', value);
            },
        });

        const selectedOneAttribute = ({ value, checked }: { value: number | string, checked: boolean }) => {
            if (checked) {
                emit('selectedOn', value);
                return;
            }
            emit('selectedOff', value);
        };

        const countFilteredHotels = computed(() => filterAttributeMethods.getCountAttribute(unref(filteredHotels)));

        const countAllHotels = computed(() => filterAttributeMethods.getCountAttribute(unref(allHotels)));

        const isDisabledAttributeFilter = (key: string, id: number) => {
            const objectCountFilteredHotels: Record<string, number> = unref(countFilteredHotels);
            if (unref(isModelValuesArray)) {
                const selectedIds = unref(selected) as number[];
                return !objectCountFilteredHotels[key] && selectedIds.indexOf(id) === -1;
            }
            return !objectCountFilteredHotels[key];
        };

        return {
            anySelectedModelArray,
            anySelectedModelNumber,
            selectedValues,
            selectedOneAttribute,
            countFilteredHotels,
            listRender: filterAttributeMethods.getListFilterAttributes(),
            countAllHotels,
            ComponentBoxList: unref(isModelValuesArray) ? CheckBoxInputListWithOneSelect : RadioInput,
            isDisabledAttributeFilter,
            isModelValuesArray,
        };
    },
});
